import { APIContext, APITypesV1 } from "@cur8/api-client";

// Mirrors SkipDrawRequest in swagger. The installed @cur8/api-client's
// generated types predate the per-tube routes, so the shape lives here until
// they catch up.
export type SkipDrawRequest = {
  reason: APITypesV1.SkipReason;
};

type SampleSelector = {
  patientId: string;
  bloodSampleId: string;
};

function drawPath(
  { patientId, bloodSampleId }: SampleSelector,
  action: string
) {
  return [
    "api",
    "v1",
    "patient",
    patientId,
    "blood-sample",
    bloodSampleId,
    "draw",
    action,
  ]
    .map(encodeURIComponent)
    .join("/");
}

/**
 * The per-tube draw routes, which the bulk `blood-sample/draw-confirm` this
 * replaces is deprecated in favour of. One tube per call is what lets the
 * plasma tube go to the lab while the operator gets help with the next
 * (AB#91601).
 *
 * Both are idempotent: re-confirming a confirmed tube writes no second custody
 * event, and re-skipping a skipped one leaves the original reason standing. So
 * a retry after a partial failure can safely re-send every tube.
 *
 * TODO: fold into @cur8/api-client's blood-sample module once it carries these,
 * the way createTimelineAPI is waiting to.
 */
export function createBloodSampleDrawAPI({ buildURL, fetchJSON }: APIContext) {
  return {
    confirmSampleDraw(sample: SampleSelector) {
      const request = new Request(buildURL(drawPath(sample, "confirm")), {
        method: "POST",
        headers: { accept: "application/json" },
      });
      return fetchJSON<APITypesV1.BloodSample>(request);
    },

    skipSampleDraw(sample: SampleSelector, skipRequest: SkipDrawRequest) {
      const request = new Request(buildURL(drawPath(sample, "skip")), {
        method: "POST",
        headers: {
          accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify(skipRequest),
      });
      return fetchJSON<APITypesV1.BloodSample>(request);
    },
  };
}
